import {persistence as licence} from 'store/licence/licenceSlice';

const persistenceConfig = {
  licence
};

export default persistenceConfig;